import { useAmazonLink } from "@/hooks/useAmazonLink";

export default function Footer() {
  const { link: amazonLink } = useAmazonLink();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 bg-void py-12"
    >
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-6 px-6 md:flex-row md:items-center md:px-12">
        <div className="flex items-center gap-3">
          <span className="h-2 w-2 bg-rebellion" />
          <span className="font-mono text-xs uppercase tracking-[0.35em] text-paper">
            election on mars
          </span>
        </div>
        <p className="font-mono text-[0.65rem] uppercase tracking-[0.2em] text-white/40">
          Power belongs strictly to the people.
        </p>
        <a
          data-testid="footer-buy-link"
          href={amazonLink}
          target="_blank"
          rel="noopener noreferrer"
          className="font-mono text-xs uppercase tracking-[0.2em] text-rebellion transition-colors hover:text-rebellion-hi"
        >
          Get the Book →
        </a>
      </div>
    </footer>
  );
}
